export const HYPERSWITCH_APPEARANCE = {
  theme: 'default',
  labels: 'above',
  variables: {
    fontFamily: '"Roboto", sans-serif',
    fontSizeBase: '16px',
    fontLineHeight: '1.35',
    colorText: '#111113',
    colorTextPlaceholder: '#1111137F',
    colorBackground: '#FFFFFF',
    colorDanger: '#E44240',
    borderRadius: '9px',
    spacingGridRow: '8px',
    spacingGridColumn: '8px',
  },
  rules: {
    '.Block': {
      backgroundColor: 'transparent !important',
      border: 'none !important',
      boxShadow: 'none !important',
      padding: '0 !important',
    },
    '.Label': { display: 'none' },
    '.AccordionItem': {
      backgroundColor: 'transparent !important',
      border: 'none !important',
      boxShadow: 'none !important',
      padding: '0 !important',
    },
    '.AccordionItemLabel': { display: 'none' },
    '.AccordionItemSelectionIcon': { display: 'none' },
    '.AccordionItemIcon--selected': { display: 'none' },
    '.PaymentMethodsHeaderLabel': { display: 'none' },
    '.SaveWalletDetailsLabel': { display: 'none' },
    '.PaymentMethodContainer': { margin: '0 !important' },
    '.AccordionContainer': { margin: '0 !important' },
    '.w-\\[47\\%\\]': { width: 'calc(50% - 4px) !important' },
    '.Input': {
      backgroundColor: '#F1F3F9 !important',
      border: '2px solid transparent !important',
      borderRadius: '9px !important',
      padding: '16px !important',
      boxShadow: '0 4px 4px 0 rgba(0,0,0,0.04) inset !important',
      color: '#111113 !important',
      fontSize: '16px !important',
      lineHeight: '1.35 !important',
    },
    '.Input::placeholder': { color: '#1111137F !important' },
    '.Input:focus': {
      border: '2px solid transparent !important',
      boxShadow: '0 4px 4px 0 rgba(0,0,0,0.04) inset !important',
    },
    '.Input--invalid': { border: '2px solid #E44240 !important' },
  },
};

export const HYPERSWITCH_PLACEHOLDER_KEYS = {
  cardNoInput: 'lp_v7_pop_up_card_number',
  cvvInput: 'lp_v7_pop_up_cvv_number',
} as const;

export const HYPERSWITCH_ELEMENT_HEIGHT = 245;

export const HYPERSWITCH_CARD_ONLY_ELEMENT_HEIGHT = 145;

export const HYPERSWITCH_CARD_ROWS_HEIGHT = 124;

export const HYPERSWITCH_WALLET_BUTTON_HEIGHT = 54;

export const HYPERSWITCH_WALLET_MOUNT_ID = 'hyperswitch-wallet-button';

export const HYPERSWITCH_ELEMENT_OPTIONS = {
  layout: { type: 'accordion', radios: false, spacedAccordionItems: false, separatorText: '' },
  hideCardNicknameField: true,
  branding: 'never',
  terms: { card: 'never' },
  wallets: {
    applePay: { buttonStyle: 'black', buttonRadius: 9 },
    googlePay: { buttonColor: 'black', buttonType: 'pay', buttonRadius: 9 },
    payPal: { display: 'never' },
  },
  displaySavedPaymentMethodsCheckbox: false,
  displaySavedPaymentMethods: false,
  paymentMethodsConfig: [
    { paymentMethod: 'wallet', message: { displayMode: 'hidden' } },
  ],
};
